import type { RetentionSettingsFetchedAction } from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsFetched';
import type { RetentionSettingsUpdatedAction } from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsUpdated';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import RetentionSettingsView from '@UI/Store/RetentionSettings/Views/RetentionSettingsView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type RetentionSettingsStore = {
	settings: RetentionSettingsView | null;
};

const initialState: RetentionSettingsStore = {
	settings: null,
};

type Actions = RetentionSettingsFetchedAction | RetentionSettingsUpdatedAction | UserRevokedAction;

const whenSettingsReceived = (
	store: RetentionSettingsStore,
	action: RetentionSettingsFetchedAction | RetentionSettingsUpdatedAction,
): RetentionSettingsStore => ({
	...store,
	settings: new RetentionSettingsView(action.payload),
});

const whenUserRevoked = (): RetentionSettingsStore => initialState;

export default registerStore<'retentionSettingsStore', Actions>(
	'retentionSettingsStore',
	createSliceReducer({
		RETENTION_SETTINGS_FETCHED: whenSettingsReceived,
		RETENTION_SETTINGS_UPDATED: whenSettingsReceived,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
